import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Rearrange icon — Figma node 8329:231590 (drag-to-reorder handle).
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const RearrangeIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g transform="translate(2.833 2.833)">
      <path
        d="M13.333 5.16699C13.333 3.54964 13.0068 2.54688 12.3965 1.93652C11.7862 1.32631 10.784 1.00004 9.16699 1H5.16699C3.54964 1 2.54688 1.32617 1.93652 1.93652C1.32617 2.54688 1 3.54964 1 5.16699V9.16699C1.00004 10.784 1.32631 11.7862 1.93652 12.3965C2.54688 13.0068 3.54964 13.333 5.16699 13.333H9.16699C10.7842 13.333 11.7862 13.0068 12.3965 12.3965C13.0068 11.7862 13.333 10.7842 13.333 9.16699V5.16699ZM14.333 9.16699C14.333 10.8828 13.9931 12.2139 13.1035 13.1035C12.2139 13.9931 10.8828 14.333 9.16699 14.333H5.16699C3.45101 14.333 2.11914 13.9932 1.22949 13.1035C0.340024 12.2139 4.29696e-05 10.8827 0 9.16699V5.16699C0 3.45101 0.339846 2.11914 1.22949 1.22949C2.11914 0.339846 3.45101 0 5.16699 0H9.16699C10.8827 4.29696e-05 12.2139 0.340024 13.1035 1.22949C13.9932 2.11914 14.333 3.45101 14.333 5.16699V9.16699Z"
        fill="currentColor"
      />
      <path
        d="M3.5732 8.21871C3.76847 8.02345 4.08497 8.02345 4.28024 8.21871L6.3066 10.2451C6.50187 10.4403 6.50187 10.7568 6.3066 10.9521C6.11134 11.1474 5.79483 11.1474 5.59957 10.9521L3.5732 8.92574C3.37794 8.73048 3.37794 8.41397 3.5732 8.21871Z"
        fill="currentColor"
      />
      <path
        d="M5.45312 10.5986V3.73242C5.45312 3.45628 5.67698 3.23242 5.95312 3.23242C6.22927 3.23242 6.45312 3.45628 6.45312 3.73242V10.5986C6.45312 10.8748 6.22927 11.0986 5.95312 11.0986C5.67698 11.0986 5.45312 10.8748 5.45312 10.5986Z"
        fill="currentColor"
      />
      <path
        d="M8.02633 3.37887C8.22159 3.18361 8.5381 3.18361 8.73336 3.37887L10.7597 5.40524C10.955 5.6005 10.955 5.91701 10.7597 6.11227C10.5645 6.30753 10.248 6.30753 10.0527 6.11227L8.02633 4.0859C7.83107 3.89064 7.83107 3.57413 8.02633 3.37887Z"
        fill="currentColor"
      />
      <path
        d="M7.87988 10.5986V3.73242C7.87988 3.45628 8.10374 3.23242 8.37988 3.23242C8.65603 3.23242 8.87988 3.45628 8.87988 3.73242V10.5986C8.87988 10.8748 8.65603 11.0986 8.37988 11.0986C8.10374 11.0986 7.87988 10.8748 7.87988 10.5986Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default RearrangeIcon;
